import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { faqs } from '../data/mockData';
import Seo from '../components/Seo';

const FAQ = () => {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((f) => ({
      "@type": "Question",
      "name": f.question,
      "acceptedAnswer": { "@type": "Answer", "text": f.answer }
    }))
  };
  return (
    <div className="min-h-screen pt-20" style={{ backgroundColor: "#0C0A09" }}>
      <Seo
        path="/faq"
        title="Peptide FAQ | Shipping, Payments & Research Use | Eman's Peppers"
        description="Answers to common questions about Eman's Peppers — shipping, payment methods (Zelle, PayPal, Cash App, Apple Pay), storage, reconstitution, and research use."
        jsonLd={faqJsonLd}
      />
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#F7F3EE] mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-[#B5A79E]">
            Everything you need to know about our peptides and services
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="bg-[#1A1513] rounded-lg shadow-sm border border-gray-200 px-6"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="text-lg font-semibold text-[#F7F3EE] pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#B5A79E] pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Contact CTA */}
        <div className="max-w-3xl mx-auto mt-16 text-center bg-gradient-to-r from-[#D4A373] to-[#C78C50] rounded-lg p-12 text-white">
          <h2 className="text-3xl font-bold mb-4">Still Have Questions?</h2>
          <p className="text-lg mb-6 opacity-90">
            Our team is here to help. Reach out and we'll get back to you as soon as possible.
          </p>
          <a href="/contact">
            <button className="bg-[#1A1513] text-teal-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors">
              Contact Us
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
